export const matchAndMergeTestIds = {
    confidenceLevel: 'confidence-level',
    keepSeparatedButton: 'keep-separated-button',
    matchingFields: 'matching-fields',
    mergeButton: 'submit-button',
    reviewLaterButton: 'review-later-button',
    selectAllFields: 'select-all-fields',
    selectField: 'select-field',
} as const;
